import React, { useState } from 'react';
import {
    Box,
    Modal,
    TextField,
    Button,
    Typography,
    CircularProgress,
    TextareaAutosize
} from '@mui/material';
import ArrowDownwardSharp from '@mui/icons-material/ArrowDownwardSharp';
import axios from 'axios';
import ReactMarkdown from 'react-markdown';
import { request } from '../../../request';

const RegerateModalForm = ({ open, onClose, userInputData }) => {
    const [inputValue, setInputValue] = useState('');
    const [responseContent, setResponseContent] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);

    const handleSubmit = async () => {
        const otherPayload = {
            subPrompt: inputValue
        };
        setLoading(true);
        const url = process.env.REACT_APP_STUDIO_BACKEND_API_URL + "v1/templates/app-template/generate-bestpractices-content";
        try {
            const resp = await request.create({
                endPoint: url,
                jsonData: {
                    actionType: "REGENERATE_COMMON",
                    userFormPayload: JSON.stringify(userInputData, null, 2),
                    otherPayload: JSON.stringify(otherPayload, null, 2)
                }
            });
            setLoading(false);
            if (typeof resp === "undefined") {
                setError(true);
                console.log("Error while calling API : ", error)
            } else {
                const content = resp?.content?.result;
                setResponseContent(content || ''); // Show response content in the additional text area
            }

        } catch (error) {
            setLoading(false);
            console.error(`Error! Status: ${error.status}`);
        }
    };

    const handleChange = (event) => {
        setInputValue(event.target.value);
    };

    return (
        <Modal
            open={open}
            onClose={onClose}
            aria-labelledby="modal-title"
            aria-describedby="modal-description"
        >
            <Box
                sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: 800,
                    bgcolor: 'background.paper',
                    boxShadow: 24,
                    p: 4,
                    borderRadius: 2
                }}
            >
                <Typography id="modal-title" variant="h6" component="h2" gutterBottom>
                    Regenerate Content
                </Typography>

                <TextareaAutosize
                    aria-label="Enter Text"
                    placeholder="Enter Text"
                    value={inputValue}
                    onChange={handleChange}
                    style={{
                        width: '100%',
                        padding: '16.5px 14px',
                        borderRadius: '4px',
                        border: '1px solid #ccc',
                        marginBottom: '16px',
                        fontSize: '16px',
                        resize: 'vertical',
                        maxHeight: '200px',
                        minHeight: '50px',
                        overflow: 'auto'
                    }}
                />
                <Button
                    variant="contained"
                    color="primary"
                    fullWidth
                    startIcon={!loading && <ArrowDownwardSharp />}
                    disabled={loading}
                    onClick={handleSubmit}
                >
                    {loading ? <CircularProgress size={24} /> : 'Submit'}
                </Button>
                <Typography
                    id="modal-description"
                    variant="body1"
                    sx={{ marginTop: 3 }}
                >
                    <strong>Response Content:</strong>
                </Typography>

                <Box
                    sx={{
                        border: '1px solid #ddd',
                        borderRadius: 2,
                        padding: 2,
                        backgroundColor: '#f5f5f5',
                        overflow: 'auto',
                        maxHeight: 300,
                    }}
                >
                    <ReactMarkdown>{responseContent}</ReactMarkdown>
                </Box>
            </Box>
        </Modal>
    );
};

export default RegerateModalForm;
